import React, { useMemo } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
} from "chart.js";
import "../../../style/workinghourstrend.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

const WorkingHoursTrend = ({ tasks = [] }) => {

  const chartData = useMemo(() => {
    const labels = ["Mon", "Tue", "Wed", "Thu", "Fri"];

    // 1️⃣ Get current week (Monday)
    const today = new Date();
    const day = today.getDay(); // Sun=0
    const monday = new Date(today);
    monday.setDate(today.getDate() - (day === 0 ? 6 : day - 1));
    monday.setHours(0, 0, 0, 0);

    // 2️⃣ Prepare date map (Mon–Fri)
    const weekMap = {};
    for (let i = 0; i < 5; i++) {
      const d = new Date(monday);
      d.setDate(monday.getDate() + i);
      weekMap[d.toDateString()] = 0;
    }

    // 3️⃣ Process tasks
    tasks.forEach(item => {
      if (!item.workDate) return;

      const taskDate = new Date(item.workDate);
      taskDate.setHours(0, 0, 0, 0);

      const key = taskDate.toDateString();
      if (weekMap[key] !== undefined) {
        weekMap[key] += Number(item.hoursSpent || 0);
      }
    });

    // 4️⃣ Build dataset in correct order
    const data = Object.values(weekMap);

    return {
      labels,
      datasets: [
        {
          data,
          borderColor: "#0f766e",
          backgroundColor: "rgba(15, 118, 110, 0.08)",
          fill: true,
          tension: 0.4,
          pointRadius: 6,
          pointBackgroundColor: "#0f766e",
          pointBorderColor: "#ffffff",
          pointBorderWidth: 2
        }
      ]
    };
  }, [tasks]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false }
    },
    scales: {
      x: {
        grid: { display: false }
      },
      y: {
        beginAtZero: true,
        max: 12,
        ticks: {
          stepSize: 2,
          callback: value => `${value}h`
        },
        grid: { color: "#f0f0f0" }
      }
    }
  };

  return (
    <div className="card working-hours-card">
   <div className="d-flex align-items-start gap-3 mb-3">
  <div className="icon-box bg-primary-light">
    <i className="fas fa-chart-line text-primary"></i>
  </div>

  <div>
    <h5 className="mb-1">Working Hours Trend</h5>
    <p className="text-muted small mb-0">
      Daily hours logged this week
    </p>
  </div>
</div>

      <div style={{ height: "280px" }}>
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
};

export default WorkingHoursTrend;
